@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

$background-image-width: 40rem;
$background-image-height: 38rem;

.title-wrapper {
  display: inline;
  margin-bottom: 3rem;
}

.choices-wrapper {
  margin-top: 4rem;
  margin-left: auto;

  @media (max-width: map.get($grid-breakpoints, md)) {
    margin-top: 2rem;
  }
}

.title {
  display: inline;

  &--with-underline {
    display: inline-block;
  }

  &--with-underline::after {
    content: '';
    display: inline-block;
    position: absolute;
    transform: translateX(-21rem);
    height: 7rem;
    width: 31rem;
    background-image: url('../../utils/Icons/QuizInngangssideUnderline.png');
    background-repeat: no-repeat;
    background-position: left bottom 2rem;
    background-size: 26rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      transform: none;
      height: unset;
      width: unset;
    }

    @media (max-width: map.get($grid-breakpoints, xs)) {
      background-image: none;
    }
  }
}
